<template>
  <div class="showPort">
    <div id="pdf"></div>
  </div>
</template>

<script>
  import Pdfh5 from "pdfh5";
  import "pdfh5/css/pdfh5.css";
  import config from "@/config";

  export default {
    name: "showPort",
    components: {},
    mounted() {
      //测试
      let {baseApi} = config;
      this.pdfh5 = new Pdfh5("#pdf", {
        data: `${baseApi}upload/download/${this.$route.query.name}`,
        pdfurl: `${baseApi}upload/download/${this.$route.query.name}`,

      });

      // 如果跳转过来有pdf链接
      // if (this.$route.query.pdf) {
      //   //实例化
      //   this.pdfh5 = new Pdfh5("#pdf", {
      //     data: this.$route.query.pdf,
      //     pdfurl: this.$route.query.pdf
      //   });
      //   //监听完成事件
      //   this.pdfh5.on("complete", function (status, msg, time) {
      //     console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum);
      //   });
      // }

    },
    data() {
      return {
        form: {
          name:this.$route.query.name
        },
        rules: {
        },
        pdfh5: null,
        totalNum: '',
      };
    },
    created() {

    },
    methods: {}
  };
</script>

<style lang='scss' scoped>

</style>
